export default __webpack_public_path__ + "static/media/tete8.9dd74e55.png";